<template>
  <div class="Box">

    <el-drawer :title="title" :visible.sync="AddBu" size="60%" :before-close="handleClose" :close-on-click-modal="false" :wrapperClosable="true">
      <div style="width: 90%; margin: 0 auto;margin-top: 20px;">
        <el-form v-if="SearchFlag" :model="queryParams" size="mini" label-width="100px" ref="ruleForm" :inline="true">
          <!-- <el-row :gutter="35"> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->
          <el-form-item label="广告ID">
            <el-input v-model="queryParams.adid" @change="search" @clear="search" placeholder="请输入广告ID" clearable></el-input>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->
          <el-form-item label="用户ID">
            <el-input v-model="queryParams.user_id" @change="search" @clear="search" placeholder="请输入用户ID" clearable></el-input>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->
          <el-form-item label="订单ID">
            <el-input v-model="queryParams.order_id" @change="search" @clear="search" placeholder="请输入订单ID" clearable></el-input>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->
          <el-form-item label="商户单号">
            <el-input v-model="queryParams.trade_no" @change="search" @clear="search" placeholder="请输入商户单号" clearable></el-input>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->

          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->
          <el-form-item label="状态">
            <el-select v-model="queryParams.status" @change="search" @clear="search" placeholder="请选择状态" clearable class="w100">
              <el-option label="全部" value=""></el-option>
              <el-option label="漏传" value="0"></el-option>
              <el-option label="已回传" value="1"></el-option>
              <el-option label="未回传" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道号">
            <el-input v-model="queryParams.channel_code" @change="search" @clear="search" placeholder="请输入渠道号" clearable></el-input>
          </el-form-item>
          <el-form-item label="选择时间">
            <el-date-picker
                @change="handTimeSucces"
                style="width: 100%"
                v-model="value1"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                type="daterange"
                align="right"
                unlink-panels
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="8" class="mb20"> -->

          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="mb20"> -->
          <el-button size="medium" type="primary" @click="search">查询</el-button>
          <el-button size="medium" @click="reset">重置</el-button>
          <!-- </el-col> -->
          <!-- </el-row> -->
        </el-form>
        <!--        <div class="div_buttom">-->
        <!--          <el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch" style="margin-top: 14px;">-->
        <!--            打开搜索-->
        <!--          </el-button>-->
        <!--        </div>-->
        <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; text-align: center; margin-top: 10px; margin-bottom: 30px"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            size="medium"
            border
            v-loading="loading"
        >
          <el-table-column label="投放媒体广告ID" width="170">
            <template slot-scope="scope">{{ scope.row.data.adid }}</template>
          </el-table-column>
          <el-table-column label="用户ID">
            <template slot-scope="scope">{{ scope.row.data.user_id }}</template>
          </el-table-column>
          <el-table-column label="订单ID">
            <template slot-scope="scope">{{ scope.row.data.order_id }}</template>
          </el-table-column>

          <el-table-column label="商户单号" width="150">
            <template slot-scope="scope">{{ scope.row.data.trade_no }}</template>
          </el-table-column>
          <el-table-column label="充值金额">
            <template slot-scope="scope">{{ scope.row.data.money }}</template>
          </el-table-column>
          <el-table-column label="回传金额">
            <template slot-scope="scope">{{ scope.row.data.real_money }}</template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">未发</span>
              <span v-else-if="scope.row.status == 1">已发</span>
              <span v-else-if="scope.row.status == 2">未回传</span>
            </template>
          </el-table-column>
          <el-table-column label="漏传原因" width="170">
            <template slot-scope="scope">{{ scope.row.lose_reason }}</template>
          </el-table-column>
          <el-table-column label="充值次数">
            <template slot-scope="scope">{{ scope.row.data.pay_count }}</template>
          </el-table-column>
          <el-table-column label="时间" width="170">
            <template slot-scope="scope">{{ scope.row.created_at }}</template>
          </el-table-column>
          <el-table-column label="渠道号" width="150">
            <template slot-scope="scope">{{ scope.row.channel_code }}</template>
          </el-table-column>

          <el-table-column label="广告类型">
            <template slot-scope="scope">{{ scope.row.ad_type == 1 ? '头条' : '--' }}</template>
          </el-table-column>
          <el-table-column label="匹配状态">
            <template slot-scope="scope">{{ scope.row.match_status == 0 ? '失败' : '成功' }}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button disabled type="text" v-if="scope.row.match_status == 1 && scope.row.status == 1" size="medium" @click="handleSend(scope.row)">
                已回传
              </el-button>
              <el-button
                  type="text"
                  v-else-if="scope.row.match_status == 1 && scope.row.status != 1"
                  size="medium"
                  @click="handleSend(scope.row)">补传
              </el-button>
              <el-button disabled type="text" v-else size="medium" @click="handleSend(scope.row)"></el-button>
              <!-- <el-button disabled type="text" v-if="scope.row.match_status == 1 || scope.row.status == '未回传'" size="medium" @click="handleSend(scope.row)">补传</el-button> -->
              <!-- <el-button type="text" size="medium" @click="handleSend(scope.row)">发送</el-button>
              <el-button type="text" size="medium" @click="handleSend(scope.row)">发送</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                    @pagination="getList"/>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {ToutiaoAPI} from '@/api/Apiret/index';
import {processErrors} from '@/utils/errorHandler';

export default {
  props: ['AddBu'],
  components: {},
  data() {
    return {
      value1: '',
      SearchFlag: true,
      title: '补传',
      queryParams: {
        adid: '',
        user_id: '',
        order_id: '',
        trade_no: '',
        status: null,
        channel_code: '',
        created_at_start: '',
        created_at_end: '',
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      loading:false,
    };
  },
  beforeDestroy() {
    this.AddBu = false; // 确保关闭弹窗
  },
  created() {
    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
    const day = ('0' + date.getDate()).slice(-2);
    const time = '00:00:00';
    const times = '23:59:59';
    const formattedDate = `${year}-${month}-${day} ${time}`;
    const formattedDates = `${year}-${month}-${day} ${times}`;
    this.value1 = [formattedDate, formattedDates];

  },
  methods: {
    addSearch() {
      this.SearchFlag = !this.SearchFlag;
    },
    // 点击查询
    search() {
      this.queryParams.pageNo = 1;
      // this.getList();
    },
    reset() {
      this.queryParams = {
        adid: '',
        user_id: '',
        order_id: '',
        trade_no: '',
        status: null,
        channel_code: '',
        created_at_start: '',
        created_at_end: '',
        pageNo: 1,
        pageSize: 10,
      };
      this.value1 = [];
      // this.getList();
    },
    //补传列表
    getList() {
      this.loading = true;
      if (this.value1) {
        this.queryParams.created_at_start = this.value1[0];
        this.queryParams.created_at_end = this.value1[1];
      }
      const api = ToutiaoAPI();
      api
          .getcallbacklist(this.queryParams)
          .then((res) => {
            if (res.code == 0) {
              this.tableData = res.data.data;
              this.total = res.data.totalCount;
            } else {
              processErrors(res);
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
    },
    handTimeSucces(e) {
      this.queryParams.created_at_start = this.value1[0];
      this.queryParams.created_at_end = this.value1[1];
      // this.getList();
    },
    handleSend(row) {
      let data = {
        ids: [row.id],
      };
      let api = ToutiaoAPI();
      api
          .getcallbacksend(data)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: '发送成功',
                type: 'success',
              });
              // this.getList();
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
            console.error('Error fetching user data:', error);
            this.loading = false;
          });
    },
    handleClose(done) {
      this.$emit('NoneDlog');
      // this.$refs['ruleForm'].resetFields();
    },
  },
  mounted() {
    // this.getList();
  },
};
</script>
<style lang="scss" scoped>
.Box {
  & ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
